import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SidebarHeaderComponent } from './sidebar-header/sidebar-header.component';
import { FooterComponent } from './footer/footer.component';
import { StepsComponent } from './steps/steps.component';
import { HeaderStepsComponent } from './header-steps/header-steps.component';
import { AlphanumericDirective } from '../../directives/alphanumeric.directive';
import { EmailDirective } from '../../directives/email.directive';
import { NumberDirective } from '../../directives/number.directive';
import { CurpDirective } from '../../directives/curp.directive';
import { OnlyLettersDirective } from '../../directives/only-letters.directive';

@NgModule({
  declarations: [
    SidebarHeaderComponent,
    FooterComponent,
    StepsComponent,
    HeaderStepsComponent,
    AlphanumericDirective,
    EmailDirective,
    NumberDirective,
    CurpDirective,
    OnlyLettersDirective
  ],
  imports: [
    CommonModule
  ],
  exports:[
    SidebarHeaderComponent,
    FooterComponent,
    StepsComponent,
    HeaderStepsComponent,
    AlphanumericDirective,
    EmailDirective,
    NumberDirective,
    CurpDirective,
    OnlyLettersDirective
  ]
})
export class SharedModule { }
